import React, { useState, useEffect } from 'react'
import { ImEqualizer2 } from 'react-icons/im'
import { IoIosSettings } from 'react-icons/io'
import { IoTrashSharp } from 'react-icons/io5'
import { useHistory, useParams } from 'react-router-dom'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import Layout from '../../components/layouts/Layout'
import http, { URL_S3 } from '../../config/BaseUrl'
import EventVideoFrame from '../events/components/Modal/EventVideoFrame'
import VideoFrameModal from '../events/components/Modal/VideoFrameModal'

const VideoFrame = () => {

    const { id } = useParams()
    const history = useHistory()

    const [selectedFrame, setSelectedFrame] = useState([])
    const [loading, setLoading] = useState(false);
    const [frame, setFrame] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const eventFrameEdit = history.location.state.eventFrameEdit

    useEffect(() => {
        if (eventFrameEdit) {
            let propsItem = []
            eventFrameEdit.forEach(item => {
                propsItem.push({ id: item.video_frame_id, image: item.video_frames.preview_image, custom_frame: item.video_frames.custom_frame.length > 0 ? item.video_frames.custom_frame[0] : null })
            })
            setSelectedFrame(propsItem)
        }
    }, [eventFrameEdit])



    const handelTemplate = async (e) => {
        e.preventDefault();
        setLoading(true)
        const submittedData = {
            photo_frame_template: selectedFrame
        }
        await http.post(`/event/video-frame/update/${id}`, submittedData).then((res) => {
            if (res) {
                setLoading(false)
                history.push(`/show/event/${id}`, 'Information Updated.')
            }
        })

    }

    const setEventFrameByProps = (data) => {
        setSelectedFrame(data)
    }

    const removeProps = (id) => {
        let copyProps = [...selectedFrame]
        copyProps.splice(id, 1)
        setSelectedFrame(copyProps)

    }

    const settingsOpen = (item) => {
        setFrame(item)
        setOpenModal(true)
    }

    const customFrame = (data, id) => {
        let frameData = [...selectedFrame]
        let dataIndex = frameData.findIndex(item => item.id === id)

        frameData[dataIndex].custom_frame = data
        setSelectedFrame([...frameData])
    }

    const closeModal = () => {
        setOpenModal(false)
    }

    return (
        <Layout>
            <NewFormWizard />
            {/* <NewFormWizardChild /> */}

            <form onSubmit={handelTemplate}>
                <section className="mt-4">
                    <div className="row justify-content-center">
                        <div className="text-center col-12 col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="">
                                        <p className="mb-0 display-4 text-primary event-form-title">Photo Template Chooser</p>
                                        <p className="mb-0 text-secondary">Select an existing template from your library, or create a new one.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-10">
                            <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <ImEqualizer2 size={30} />
                                        <p className="mb-0 ml-2 font-size-16">Template Library</p>
                                    </div>
                                    <div className="float-right">
                                        <button type="button" className="mr-3 btn btn-outline-primary" data-toggle="modal" data-target="#event-frame-modal">Select</button>
                                        <EventVideoFrame setData={setEventFrameByProps} selectedFrame={selectedFrame} />
                                    </div>
                                </div>
                                <div className="prop__area">
                                    <div className="props-list d-flex flex-wrap">
                                        {
                                            selectedFrame.length > 0 ?
                                                selectedFrame.map((propItem, index) => (
                                                    <div className="prop__item" key={`digital-props-index-${index}`}>
                                                        <img src={`${URL_S3}image/video_frames/preview_image/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                        {
                                                            propItem.custom_frame &&
                                                            <img 
                                                                src={`${URL_S3}image/video_frame/frame_image/custom_frame/${propItem.custom_frame.frame}`} className="img-fluid" alt='no'
                                                                style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', maxHeight: '150px', maxWidth: `150px`, objectFit: 'contain'}} 
                                                            />
                                                        }
                                                        <div className="remove-props d-flex justify-content-around align-items-center">
                                                            <span className="font-small" onClick={removeProps.bind(this, index)}>
                                                                <IoTrashSharp />
                                                            </span>
                                                            <span className="font-small" onClick={settingsOpen.bind(this, propItem)}>
                                                                <IoIosSettings />
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))

                                                :
                                                <div className="prop__no__item">
                                                    <h4>No Template Selected.</h4>
                                                </div>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                        {
                        openModal &&
                            <VideoFrameModal isOpen={openModal} closeModal={closeModal} eventId={id} setSelectedFrame={setFrame} selectedFrame={frame} setCustomFrame={customFrame} />
                        }
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-10">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default VideoFrame
